var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppNavAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nav icon/3 My Account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "8.8817842e-16 0 13.002 0 13.002 13.0037 8.8817842e-16 13.0037"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-icon/3-My-Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.800000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.498827, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.501,2.3547 C8.787,2.3547 10.648,4.2147 10.648,6.5017 C10.648,8.7887 8.787,10.6487 6.501,10.6487 C4.215,10.6487 2.355,8.7887 2.355,6.5017 C2.355,4.2147 4.215,2.3547 6.501,2.3547 M6.501,13.0037 C10.086,13.0037 13.002,10.0877 13.002,6.5017 C13.002,2.9177 10.086,-0.0003 6.501,-0.0003 C2.916,-0.0003 8.8817842e-16,2.9177 8.8817842e-16,6.5017 C8.8817842e-16,10.0877 2.916,13.0037 6.501,13.0037",
    id: "Fill-1",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.7307934,17.9267 C15.5878593,15.3357 12.4279089,13.8487 9.06005528,13.8487 C5.61030031,13.8487 2.40084918,15.3947 0.255214988,18.0917 C-0.149791465,18.6017 -0.0633900881,19.3417 0.447818057,19.7457 C0.664721513,19.9177 0.924825657,19.9997 1.18132974,19.9997 C1.53053531,19.9997 1.87704083,19.8467 2.11014454,19.5537 C3.80307152,17.4237 6.33661189,16.2027 9.06005528,16.2027 C11.7168976,16.2027 14.2126374,17.3767 15.9037643,19.4227 C16.3195709,19.9247 17.0638828,19.9977 17.5687909,19.5827 C18.0727989,19.1707 18.1457,18.4297 17.7307934,17.9267",
    id: "Fill-4",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppNavAccount);
export default __webpack_public_path__ + "static/media/app_nav_account.42b1d7607b9e1e8ae98a548027ab129b.svg";
export { ForwardRef as ReactComponent };